import { DefaultCellHeader } from "app/components/React/Table/headerCells";
import { translate } from "app/filters/i18nFilter";
import { FavoritesCell } from "app/components/React/Table/cells/FavoritesCell";
import { ChangePercentage, DefaultCellRightAlign } from "app/components/React/Table/cells";
import { CHART_COLORS } from "app/constants/ChartColors";
import { CategoryCell } from "app/components/React/Table/cells/category-cell/CategoryCell";
import { onCategoryCellClick } from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/columns/utils";

const DefaultCellHeaderRightAlign = (props) => (
    <DefaultCellHeader
        {...props}
        className={"right-align"}
    />
);

const favorite = {
    field: "isFavorite",
    displayName: () => translate("common.star"),
    tooltip: () => translate("pre.defined.industries.table.columns.favorites.tooltip"),
    fixed: true,
    cellComponent: FavoritesCell,
    headerComponent: DefaultCellHeader,
    width: 50,
    isResizable: false,
    cellClass: "clickable",
};

const industry = {
    field: "industry",
    displayName: () => translate("common.industry"),
    tooltip: () => translate("pre.defined.industries.table.columns.industry.tooltip"),
    cellComponent: (props) => (
        <CategoryCell
            {...props}
            trackOnClick={onCategoryCellClick}
        />
    ),
    headerComponent: DefaultCellHeader,
    width: 320,
    isResizable: true,
    sortable: true,
};

const totalVisits = {
    field: "totalVisits",
    displayName: () => translate("pre.defined.industries.table.columns.total.visits"),
    tooltip: () => translate("pre.defined.industries.table.columns.total.visits.tooltip"),
    format: "minVisitsAbbr",
    sortable: true,
    headerComponent: DefaultCellHeaderRightAlign,
    cellComponent: DefaultCellRightAlign,
    width: 155,
    minWidth: 155,
    isResizable: true,
};

const totalVisitsChange = {
    field: "totalVisitsChange",
    displayName: () => translate("pre.defined.industries.table.columns.total.visits.change"),
    tooltip: () => translate("pre.defined.industries.table.columns.total.visits.change.tooltip"),
    format: "number",
    sortable: true,
    headerComponent: DefaultCellHeaderRightAlign,
    cellComponent: ChangePercentage,
    showTotalCount: false,
    width: 158,
    minWidth: 158,
    isResizable: true,
};

const uniqueVisitors = {
    field: "uniqueVisitors",
    displayName: () => translate("pre.defined.industries.table.columns.unique.visitors"),
    tooltip: () => translate("pre.defined.industries.table.columns.unique.visitors.tooltip"),
    format: "minVisitsAbbr",
    sortable: true,
    headerComponent: (props) => <DefaultCellHeaderRightAlign {...props} />,
    cellComponent: DefaultCellRightAlign,
    width: 155,
    minWidth: 155,
    isResizable: true,
};

const uniqueVisitorsChange = {
    field: "uniqueVisitorsChange",
    displayName: () => translate("pre.defined.industries.table.columns.unique.visitors.change"),
    tooltip: () => translate("pre.defined.industries.table.columns.unique.visitors.change.tooltip"),
    format: "number",
    sortable: true,
    headerComponent: DefaultCellHeaderRightAlign,
    cellComponent: ChangePercentage,
    showTotalCount: false,
    width: 158,
    isResizable: true,
};

const previousPeriodTotalVisits = {
    ...totalVisits,
    field: "previousPeriodTotalVisits",
    tooltip: () => translate("pre.defined.industries.table.columns.total.visits.previous.period.tooltip"),
    headerComponent: (props) => (
        <DefaultCellHeaderRightAlign
            {...props}
            bulletColor={CHART_COLORS.periodOverPeriod.Total[1]}
        />
    ),
    width: 130,
};

const currentPeriodTotalVisits = {
    ...totalVisits,
    tooltip: () => translate("pre.defined.industries.table.columns.total.visits.current.period.tooltip"),
    headerComponent: (props) => (
        <DefaultCellHeaderRightAlign
            {...props}
            bulletColor={CHART_COLORS.periodOverPeriod.Total[0]}
        />
    ),
    width: 130,
};

const periodOverPeriodTotalVisitsChange = {
    ...totalVisitsChange,
    displayName: () => translate("pre.defined.industries.table.columns.total.visits.period.over.period.change"),
    tooltip: () => translate("pre.defined.industries.table.columns.total.visits.period.over.period.change.tooltip"),
    width: 110,
};

const previousPeriodUniqueVisitors = {
    ...uniqueVisitors,
    field: "previousPeriodUniqueVisitors",
    tooltip: () => translate("pre.defined.industries.table.columns.period.over.period.unique.visitors.tooltip"),
    headerComponent: (props) => (
        <DefaultCellHeaderRightAlign
            {...props}
            bulletColor={CHART_COLORS.periodOverPeriod.Total[1]}
        />
    ),
    width: 170,
};

const currentPeriodUniqueVisitors = {
    ...uniqueVisitors,
    headerComponent: (props) => (
        <DefaultCellHeaderRightAlign
            {...props}
            bulletColor={CHART_COLORS.periodOverPeriod.Total[0]}
        />
    ),
    width: 170,
};

const periodOverPeriodUniqueVisitorsChange = {
    ...uniqueVisitorsChange,
    displayName: () => translate("pre.defined.industries.table.columns.unique.visitors.period.over.period.change"),
    tooltip: () => translate("pre.defined.industries.table.columns.unique.visitors.period.over.period.change.tooltip"),
    width: 110,
};

export const columns = {
    favorite,
    industry,
    totalVisits,
    uniqueVisitors,
    totalVisitsChange,
    uniqueVisitorsChange,
    previousPeriodTotalVisits,
    currentPeriodTotalVisits,
    periodOverPeriodTotalVisitsChange,
    previousPeriodUniqueVisitors,
    currentPeriodUniqueVisitors,
    periodOverPeriodUniqueVisitorsChange,
};
